export default __webpack_public_path__ + "images/7d812711e1c79787f4ced5b1c78d9a11.png";